// Components
import Listing from '@/views/reviews/Listing.vue';

export default [
  {
    path: '',
    redirect: { name: 'listing-embed' },
  },
  {
    path: 'listing',
    name: 'listing-embed',
    component: Listing,
  },
];
